import React from "react";
import styled from "styled-components";
import { Switch, Route, useLocation, useHistory } from "react-router-dom";
import { NewMeal } from "./NewMeal";
import { UneatenMeals } from "./UneatenMeals";
import { Menu, MenuItem } from "semantic-ui-react";
import { PastMeals } from "./PastMeals";

function App() {
  const history = useHistory();
  const location = useLocation();
  const pathname = location?.pathname;

  return (
    <AppContainer>
      <Header>
        <Menu>
          <MenuItem
            name="uneaten"
            active={pathname === "/" || pathname === "/uneaten"}
            onClick={() => history.push("/uneaten")}
          >
            Uneaten
          </MenuItem>

          <MenuItem
            name="add"
            active={pathname === "/add"}
            onClick={() => history.push("/add")}
          >
            Add Meal
          </MenuItem>
          <MenuItem
            name="past"
            active={pathname === "/past"}
            onClick={() => history.push("/past")}
          >
            The Past
          </MenuItem>
        </Menu>
      </Header>
      <TheRest>
        <Switch>
          <Route path="/add">
            <NewMeal />
          </Route>
          <Route path="/past">
            <PastMeals />
          </Route>
          <Route path={["/uneaten", "/"]}>
            <UneatenMeals />
          </Route>
        </Switch>
      </TheRest>
    </AppContainer>
  );
}

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 100vh;
  background-color: #282c34;
  font-size: calc(10px + 2vmin);
  color: white;
  padding: 8px;
`;

const Header = styled.div`
  height: 40px;
  width: 100%;
  font-size: 30px;
  font-weight: 500;
`;

const TheRest = styled.div`
  height: calc(100vh - 40px);
  width: 100%;
`;

export default App;
